import React from 'react';
import { personalInfo } from '../data/personal';

// Monogram emblem — mirrors public/logo.svg (used as the favicon)
export const LogoMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lm-rim" x1="8" y1="8" x2="120" y2="120" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34d399" />
        <stop offset="1" stopColor="#d4af37" />
      </linearGradient>
      <linearGradient id="lm-ring" x1="30" y1="26" x2="98" y2="104" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6ee7b7" />
        <stop offset="0.55" stopColor="#10b981" />
        <stop offset="1" stopColor="#d4af37" />
      </linearGradient>
      <radialGradient id="lm-top" cx="0.5" cy="0.05" r="0.75">
        <stop stopColor="#10b981" stopOpacity="0.35" />
        <stop offset="1" stopColor="#10b981" stopOpacity="0" />
      </radialGradient>
    </defs>
    <rect x="6" y="6" width="116" height="116" rx="30" fill="#06120c" />
    <rect x="6" y="6" width="116" height="116" rx="30" fill="url(#lm-top)" />
    <rect x="7.5" y="7.5" width="113" height="113" rx="28.5" fill="none" stroke="url(#lm-rim)" strokeWidth="3" />
    <circle cx="64" cy="66" r="29" fill="none" stroke="url(#lm-ring)" strokeWidth="12" strokeLinecap="round" />
    <circle cx="85" cy="45" r="9" fill="#06120c" />
    <circle cx="85" cy="45" r="6.5" fill="#f0dc9a" />
  </svg>
);

const Logo: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className="w-9 h-9 sm:w-10 sm:h-10 shrink-0 drop-shadow-[0_0_10px_rgba(16,185,129,0.35)]" />
    <div className="leading-none text-left">
      <div className="text-base sm:text-lg font-bold bg-gradient-to-r from-emerald-400 to-gold-400 bg-clip-text text-transparent">
        {personalInfo.name}
      </div>
      <div className="text-[9px] sm:text-[10px] font-semibold tracking-[0.28em] text-emerald-300/70 mt-1">
        {personalInfo.title.toUpperCase()}
      </div>
    </div>
  </div>
);

export default Logo;
